export const isSome = (input) => input != null;
export const isNone = (input) => input == null;
